import clsx from "clsx";
import { ConditionalTooltip } from "components/ConditionalTooltip";
import { IconText } from "components/IconText";
import { GlobalContext } from "contexts/GlobalContext";
import { useContext } from "react";
import { useHistory } from "react-router-dom";

export const DeleteGameButton = (props: {
    code: string;
    gameName?: string;
    redirect?: string;
    onDeleted?: () => void;
    btnClass?: string;
    iconDanger?: boolean;
    placement: "top" | "bottom" | "left" | "right";
}) => {
    const { gameName, code, redirect, btnClass = "dropdown-item", iconDanger = true, onDeleted, placement } = props;

    const history = useHistory();

    const { moderateService, setWindowConfirm, catchServerError, addNotification } = useContext(GlobalContext);
    const { deleteGame } = moderateService;

    return (
        <ConditionalTooltip show={true} text="Delete game" placement={placement}>
            <button
                type="button"
                className={btnClass}
                data-bs-toggle="modal"
                data-bs-target="#window-confirm"
                onClick={() => {
                    setWindowConfirm({
                        confirmText: "Delete game",
                        confirmIcon: "fas fa-trash",
                        confirmDescription: (
                            <div className="vstack gap-3">
                                <div>
                                    Are you sure you want to delete <strong>{gameName ?? "this game"}</strong>?
                                </div>

                                <div>This may take a minute, Franky is working hard to make this experience better</div>
                            </div>
                        ),
                        onConfirm: () => {
                            setWindowConfirm(
                                old =>
                                    old && {
                                        ...old,
                                        loading: true,
                                    },
                            );

                            deleteGame(code)
                                .then(x => {
                                    if (x.success) {
                                        if (redirect) {
                                            history.push(redirect);
                                        }

                                        if (onDeleted) {
                                            onDeleted();
                                        }

                                        setWindowConfirm(
                                            old =>
                                                old && {
                                                    ...old,
                                                    loading: false,
                                                    successMessage: "Game deleted",
                                                },
                                        );
                                    } else {
                                        setWindowConfirm(
                                            old =>
                                                old && {
                                                    ...old,
                                                    loading: false,
                                                },
                                        );

                                        addNotification({
                                            type: "failure",
                                            title: "Delete game failed",
                                        });
                                    }
                                })
                                .catch(catchServerError);
                        },
                    });
                }}
            >
                <IconText icon={clsx("fat fa-trash-can", iconDanger && "text-danger")} text="" />
            </button>
        </ConditionalTooltip>
    );
};
